import { makeAutoObservable, toJS } from 'mobx'
import { restaurantConfig, productMobx, restaurantCenter, RESTAURANT_EVENT, cartMobx, feeMobx, Console, orderMobx } from '..'
import { ddayjs, toDecimal } from '@dt/fe-utils'
import { forEach, mapValues, pick, size, sortBy, isEmpty, uniqBy, omit, keyBy, cloneDeep, filter, flatten, remove, groupBy, map, last } from '@dt/fe-utils/dist/lodash'
import boxFeeMobx from './boxFee.mobx'

let sstime = 0

const console = new Console('console.discount')
const getDefaultAction = () => ({
  promoCodes: [],
  orderPlan: null,
  itemPlan: {},
  isCashPay: false,
  selectCouponIds: [],
  isUseIntegral: false,
  selectItemCouponMap: {},
  selectItemCouponIds: [],
  isSelectCoupon: false
})

const getDefaultResult = () => ({
  itemMap: {},
  memberCouponMap: {},
  memberItemCouponMap: {},
  offArr: [],
  usePromoCodeStatus: 'unused' as 'effective' | 'unused' | 'ineffective',
  sk: '',
  version: '',
  memberId: 0,
  memberCardId: 0,
  floorPayType: undefined,
  floorType: undefined,
  integral: undefined,
  isIntegralMoney: false,
  getIntegral: 0,
  floorOff: undefined,
  integralMoneyOff: undefined,
  promoCodeOff: undefined,
  orderPlanOff: undefined,
  promoCodeActivity: [],
  singleItemSwapBuyMap: {},
  fullItemNFreeMap: {},
  noPurchasedCardMap: {},
  designatedBuyAgain: undefined,
  orderSwapBuy: {}
})

/**
 * {
    useIntegral: undefined,
    integralDiscountMoney: undefined,
    memberCardIntegral: undefined
  }
 */

class Discount {
  constructor () {
    makeAutoObservable(this)
    restaurantCenter.on(RESTAURANT_EVENT.CONFIG_MPC_UPDATED, () => {
      if (restaurantConfig.mpc) {
        restaurantConfig.mpc.addConcessionListener('order_settlement', this.listenCart.bind(this))
        restaurantConfig.mpc.addConcessionListener('menu_list', this.listenMenu.bind(this))
      }
      // this.calcMenu()
    })
    restaurantCenter.on(RESTAURANT_EVENT.MENU_MALL_CHANGE, () => {
      this.calcMenu()
      this.calcCart()
    })
    restaurantCenter.on(RESTAURANT_EVENT.MENU_END, () => {
      this.calcMenu()
    })
    restaurantCenter.on(RESTAURANT_EVENT.CART_ITEMS_CHANGED, ({ type, cartItem, itemPlan }) => {
      if (type === 'add' || type === 'change') {
        this.setItemPlan(cartItem.pk, itemPlan || null)
        this.setOrderPlan()
      } else if (type === 'remove') {
        this.setItemPlan(cartItem.pk, null)
        this.setOrderPlan()
      } else if (type === 'clear') {
        this.clearDiscountAction()
      }
    })
    restaurantCenter.on(RESTAURANT_EVENT.CART_ORDERITEMS_CHANGED, () => {
      this.setOrderPlan()
      this.calcCart()
    })
    restaurantCenter.on(RESTAURANT_EVENT.CART_RESET, () => {
      this.switchEatType(restaurantConfig.app === 'pos' ? 'dinein' : cartMobx.info.eatType)
      this.clearDiscountAction()
    })
    restaurantCenter.on(RESTAURANT_EVENT.CART_CHANGED, () => {
      this.calcCart()
    })
    restaurantCenter.on([
      RESTAURANT_EVENT.CART_ITEMS_PRICE_UPDATE, // 购物车价格有变化
      RESTAURANT_EVENT.CART_ITEMS_INVALID, // 购物车部分餐品不可用
      RESTAURANT_EVENT.CART_ORDERITEMS_CHANGED, // 购物车已下单的餐品发生变化
      RESTAURANT_EVENT.CART_FEE_CITYID_CHANGED // 购物车税区发生变化
    ], () => {
      this.calcCart()
    })
  }

  /** 餐品级优惠的自定义折扣 */
  itemPlanMap: {
    [productNo: string]: IDiscountPlanConfig;
  } = {}

  /** 整单优惠的原因和自定义优惠 */
  orderPlan: IDiscountPlanConfig = {
    planId: 0,
    reasons: [],
    tags: [],
    roles: []
  }

  /** 菜单级优惠的数据支持 */
  itemDiscountMap: {
    [productNoScale: string]: {
      /** 优惠减去的金额 （差额） */
      off: number;
      /** 优惠的原因 */
      offTip: string;
      /** 原价 */
      price: number;
      /** 优惠ID */
      promId: string;
      /** 会员价 */
      memberPrice?: number;
      offType?: 'memberPrice';
    };
  } = {}

  /** 门店活动列表 */
  activities: any[] = []

  /** 营销动作 */
  discountAction: IDiscountAction = getDefaultAction()

  /** 购物车优惠-- 原数据 */
  discountResult: IDiscountResult = getDefaultResult()

  /** 是否有手工折扣 */
  get hasPlanAction () {
    return !!this.discountAction.orderPlan
  }

  /** 根据营销动作计算出传给三方的动作对象 */
  get actionPlan () {
    let actionPlan: any = {}
    const orderPlan = this.discountAction.orderPlan
    if (orderPlan) {
      actionPlan.orderPlan = {
        discountReason: orderPlan.reason,
        discountType: orderPlan.type,
        discountValue: orderPlan.value,
        tagId: orderPlan.tagId,
        planId: this.orderPlan.planId,
        addUserId: restaurantConfig.managerId,
        addUserName: restaurantConfig.managerName,
        isLock: orderPlan.isLock
      }
    }
    if (size(this.discountAction.itemPlan)) {
      actionPlan.itemPlan = mapValues(this.discountAction.itemPlan, (item) => ({
        discountReason: item.reason,
        discountType: item.type,
        discountValue: item.value,
        isIncludeModifier: item.isIncludeModifier,
        tagId: item.tagId,
        planId: this.orderPlan.planId,
        addUserId: restaurantConfig.managerId,
        addUserName: restaurantConfig.managerName
      }))
    }
    if (this.discountAction.promoCodes.length) {
      actionPlan.promoCodes = this.discountAction.promoCodes
    }
    if (this.discountAction.selectCouponIds.length) {
      actionPlan.selectCouponIds = toJS(this.discountAction.selectCouponIds)
    }
    if (this.discountAction.isUseIntegral) {
      actionPlan.isUseIntegral = true
    }
    // if (!isEmpty(this.discountAction.selectItemCouponIds)) {
    //   actionPlan.selectItemCouponIds = toJS(this.discountAction.selectItemCouponIds)
    // }
    if (!isEmpty(Object.values(this.discountAction.selectItemCouponMap).filter(Boolean))) {
      actionPlan.selectItemCouponMap = toJS(this.discountAction.selectItemCouponMap)
    }
    // const isNoAction = isEmpty(actionPlan)
    if (this.discountAction.isCashPay) {
      actionPlan.isCashPay = true
    }
    actionPlan.isSelectCoupon = this.discountAction.isSelectCoupon //  ? false : true
    if (this.discountAction.mockCardRechargeId !== undefined) {
      actionPlan.mockCardRechargeId = this.discountAction.mockCardRechargeId
    }
    if (this.discountAction.mockCardRechargeMoney !== undefined) {
      actionPlan.mockCardRechargeMoney = this.discountAction.mockCardRechargeMoney
    }
    if (this.discountAction.mockCardRechargeUseCoupon !== undefined) {
      actionPlan.mockCardRechargeUseCoupon = this.discountAction.mockCardRechargeUseCoupon
    }
    if (this.discountAction.onlyBalancePay !== undefined) {
      actionPlan.onlyBalancePay = this.discountAction.onlyBalancePay
    }
    return actionPlan
  }

  // TODO 当前并非在用的所有的优惠类型的合集，只是当前的
  /** 当前在用的餐品级的优惠 */
  get itemTagPlans () {
    const itemPlanMap = this.itemPlanMap
    const tagPlanIdToItem: {
      [tagId: number]: IDiscountTag;
    } = {}
    for (const productNo in itemPlanMap) {
      if (itemPlanMap[productNo].tags.length) {
        itemPlanMap[productNo].tags.map(tag => {
          if (!tagPlanIdToItem[tag.tagId]) {
            tagPlanIdToItem[tag.tagId] = tag
          }
        })
      }
    }
    return Object.values(tagPlanIdToItem)
  }

  /** 根据餐品级优惠，返回支持餐品列表 */
  get itemTagPlanIdToItem () {
    const itemPlanMap = this.itemPlanMap
    const tagPlanToItem: {
      [tagId: number]: string[];
    } = {}
    for (const productNo in itemPlanMap) {
      if (itemPlanMap[productNo].tags.length) {
        itemPlanMap[productNo].tags.map(tag => {
          if (tagPlanToItem[tag.tagId]) {
            tagPlanToItem[tag.tagId].push(productNo)
          } else {
            tagPlanToItem[tag.tagId] = [productNo]
          }
        })
      }
    }
    return tagPlanToItem
  }

  /** 根据返回的券信息计算整单券列表 */
  get wholeCoupons (): IDiscountCoupon[] {
    return sortBy(Object.values(this.discountResult.memberCouponMap || {}).map((coupon: any) => {
      const endTimeStamp = ddayjs(coupon.endTime).valueOf()
      const isLastDay = ddayjs().format('YYYY-MM-DD') === ddayjs(endTimeStamp - 1).format('YYYY-MM-DD')
      return { ...pick(coupon, 'couponName', 'canUseProductPk', 'couponId', 'picture', 'discountType', 'discountValue', 'orderFee', 'memberCouponId', 'isSelect', 'status', 'type', 'isAllStore', 'startTime', 'endTime', 'stores', 'isAllTime', 'effectDay'), isForever: endTimeStamp > 32503651200000, endTimeStamp, isLastDay }
      // 排序 1. disabled 排下面 2. 不可用最后 3. 结束时间越早越前
      // 按品类排，满减券、代金券（红包） 按类型排，减价券、折扣券
      // 按折扣力度排，力度大的排在前面 按过期时间排，要过期的排前面
      // 最后按ID排一次
    }), c => {
      return (100000 * (c.status === 'disable' ? 1 : 0)) + (10000 * (c.type === 'cash' ? 1 : 0)) + (1000 * (c.discountType === 'discountRate' ? 1 : 0)) + (100 * (c.discountValue / 100000) * (c.discountType === 'discountRate' ? 1 : -1)) + c.endTimeStamp / 10000000000000 + c.memberCouponId / 1000000000
    })
  }

  /** 根据返回的券信息计算餐品券列表 */
  get singleCoupons (): IDiscountItemCoupon[] {
    return sortBy(Object.values(this.discountResult.memberItemCouponMap || {}).map((coupon) => {
      const endTimeStamp = ddayjs(coupon.endTime).valueOf()
      const isLastDay = ddayjs().format('YYYY-MM-DD') === ddayjs(endTimeStamp - 1).format('YYYY-MM-DD')
      const products = uniqBy((coupon.pks || []).filter((pk: string) => cartMobx.pkToAvailableDiscountItemMap[pk]).map((pk: string) => {
        return { ...pick(cartMobx.pkToAvailableDiscountItemMap[pk], 'productNo', 'scaleNo', 'name', 'scaleName', 'pk'), img: productMobx.noToViewProductMap[cartMobx.pkToAvailableDiscountItemMap[pk].productNo]?.pic }
      }), (p: any) => p.productNo + p.scaleNo)
      const useItem = coupon.useItem && cartMobx.pkToAvailableDiscountItemMap[coupon.useItem.pk] ? pick(cartMobx.pkToAvailableDiscountItemMap[coupon.useItem.pk], 'productNo', 'scaleNo', 'name', 'scaleName', 'pk') : null
      const isSelect = !!useItem
      return { ...pick(coupon, 'couponId', 'canUseProductPk', 'couponName', 'picture', 'discountType', 'discountValue', 'orderFee', 'memberCouponId', 'status', 'type', 'isAllStore', 'startTime', 'endTime', 'stores', 'isAllTime'), products, useItem, isSelect, isForever: endTimeStamp > 32503651200000, endTimeStamp, isLastDay }
    }), c => {
      return (100000 * (c.status === 'disable' ? 1 : 0)) + (10000 * (c.type === 'cash' ? 1 : 0)) + (1000 * (c.discountType === 'discountRate' ? 1 : c.discountType === 'discountFee' ? 0.5 : 0)) + (100 * (c.discountValue / 100000) * (c.discountType === 'discountRate' ? 1 : -1)) + c.endTimeStamp / 10000000000000 + c.memberCouponId / 1000000000
    })
  }

  /** 可用券数量 */
  get enabledCouponCnt () {
    return this.wholeCoupons.filter(coupon => coupon.status === 'enable' && coupon.isSelect === false).length + this.singleCoupons.filter(coupon => coupon.isSelect === false && coupon.status === 'enable').length
  }

  /** 使用券数量 */
  get usedCouponCnt () {
    return this.wholeCoupons.filter(coupon => coupon.isSelect).length + this.singleCoupons.filter(coupon => coupon.isSelect).length
  }

  /** 使用优惠码数量 */
  get usedPromoCodeCouponsCnt () {
    return this.promoCodeCoupons.filter(coupon => coupon.status === 'enable').length
  }

  /** 使用优惠的数量(券+优惠码) */
  get usedDiscountCnt () {
    return this.usedCouponCnt + this.usedPromoCodeCouponsCnt
  }

  /** 将使用的优惠码也包装成券的模型 */
  get promoCodeCoupons (): IDiscountCoupon[] {
    return this.discountResult?.promoCodeActivity.map(activity => {
      const endTimeStamp = ddayjs(activity.endTime).valueOf()
      const isLastDay = ddayjs().format('YYYY-MM-DD') === ddayjs(endTimeStamp - 1).format('YYYY-MM-DD')
      let { discountType, discountValue, orderFee } = activity
      if (activity.status !== 'enable' && activity.extra?.ladderDiscount?.length) {
        const info: any = last(activity.extra.ladderDiscount)
        discountType = info.discountType
        discountValue = info.discountValue
        orderFee = info.orderFee
      }
      return {
        ...pick(activity, 'canUseProductPk', 'couponId', 'picture', 'status', 'startTime', 'endTime', 'isAllStore', 'isAllTime', 'promoCode', 'picture'),
        discountType,
        discountValue,
        orderFee,
        couponName: activity.activityName,
        memberCouponId: activity.activityId,
        isSelect: true, // this.discountAction.promoCodes.includes(activity.promoCode),
        // enable 可用 disable 不可用 mutex 互斥
        /** 券类型 */
        type: 'order',
        endTimeStamp,
        isForever: false,
        stores: [],
        isLastDay,
        isAllProduct: activity.productRelation === 'all' && activity.productComboRelation === 'all',
        activityType: activity.type
      }
    })
  }

  /** 整单换购活动数据 */
  get orderSwapBuyActivity (): IOrderSwapBuyActivity | undefined {
    return this.discountResult.orderSwapBuy?.activity
  }

  /** 整单换购活动原始全部的餐品 */
  get allOrderSwapBuyActityProducts () {
    const products = this.discountResult.orderSwapBuy?.activity?.products || []
    return products
  }

  /** 整单换购活动支持的餐品集合 */
  get orderSwapBuyActityProductMap () {
    return keyBy(this.allOrderSwapBuyActityProducts, 'productNo')
  }

  /** 添加到购物车的整单换购餐品对象集合 */
  get allOrderSwapBuyActityProductsMap () {
    const productMap = this.discountResult.orderSwapBuy?.productMap || {}
    return productMap
  }

  /** 整单换购活动的餐品 */
  get orderSwapBuyActivityProducts () {
    const products = this.discountResult.orderSwapBuy?.activity?.products || []
    let viewActivityProducts: IViewProduct[] = []
    if (restaurantConfig.app === 'pos') {
      viewActivityProducts = products
        .filter((item) => item.cnt > 0)
        .filter(item => productMobx.noToViewProductMap[item.productNo])
        .map((item) => {
          const product: IOrderSwapBuyProduct = cloneDeep(productMobx.noToViewProductMap[item.productNo])
          const scales = product.scales?.filter(scale => scale.status !== 'disable')?.filter(scale => scale.no === item.scaleNo)
          if (scales[0]) {
            if (scales[0].saleCnt !== undefined) {
              product.saleCnt = scales[0].saleCnt
              product.saleTotalCnt = scales[0].saleTotalCnt
            }
            if (!scales[0].isOpenPrice) {
              scales[0].actualPrice = item.activityPrice
              scales[0].discountPrice = scales[0].price ? toDecimal(scales[0].price - item.activityPrice) as number : 0
              product.price = scales[0].price ? scales[0].price : product.price
              product.actualPrice = scales[0].actualPrice || 0
              product.offPrice = scales[0].discountPrice || 0
            }
          }
          product.cnt = item.cnt
          product.scales = scales
          return product
        })
        .filter(item => !!item.scales?.length)
        .filter(item => item.isNotSingleInCombo && !item.disable && item.saleCnt !== 0)
    } else {
      const activityProducts = products
        .filter((item) => item.cnt > 0)
        .filter(item => productMobx.noToViewProductMap[item.productNo])
      const activityProductsGroups: any = groupBy(activityProducts, 'productNo')
      viewActivityProducts = map(activityProductsGroups, (item, key) => {
        const scaleNosMap = keyBy(item, 'scaleNo')
        const product = cloneDeep(productMobx.noToViewProductMap[key])
        const scales = product.scales?.filter(scale => scale.status !== 'disable')
        let theScaleNo = '0'
        let minPrice = 999999
        scales?.forEach(scale => {
          const _scale = scaleNosMap?.[scale.no]
          scale.disable = !_scale
          if (_scale) {
            if (!scale.isOpenPrice) {
              scale.actualPrice = _scale.activityPrice
              scale.discountPrice = scale.price ? toDecimal(scale.price - _scale.activityPrice) as number : 0
            }
            if (scale && ((scale.price || 0) <= minPrice)) {
              minPrice = scale.price || 0
              theScaleNo = scale.no
            }
          } else {
            if (!scale.isOpenPrice && scale.price) {
              if (this.itemDiscountMap && this.itemDiscountMap[product?.no + '_' + scale.no]) {
                scale.discountPrice = this.itemDiscountMap[product?.no + '_' + scale.no].off
                scale.actualPrice = toDecimal(scale.price - scale.discountPrice) as number
              } else {
                scale.discountPrice = 0
                scale.actualPrice = scale.price
              }
            }
          }
        })
        const theScale = scales?.find(item => item.no === theScaleNo)
        product.price = theScale?.price ? theScale.price : product.price
        product.actualPrice = theScale?.actualPrice || 0
        product.offPrice = theScale?.discountPrice || 0
        return product
      })
        .filter(item => !!item.scales?.length)
        .filter(item => item.isNotSingleInCombo && item.isShowInMenu && !item.disable && item.saleCnt !== 0)
    }
    return viewActivityProducts
  }

  /** 单品换购营销map */
  get singleSwapBuyMap () {
    const singleSwapBuyMap = {} as {
      [pk: string]: IDiscountSingleSwapBuyMapItem;
    }
    const singleItemSwapBuyMap = this.discountResult.singleItemSwapBuyMap
    Object.keys(this.discountResult.singleItemSwapBuyMap).forEach(key => {
      const { surplusCnt, activityProducts, validProducts } = singleItemSwapBuyMap[key]
      const viewActivityProducts = activityProducts
        .filter(item => item.cnt > 0)
        .filter(item => productMobx.noToViewProductMap[item.productNo])
        .map(item => {
          const product = cloneDeep(productMobx.noToViewProductMap[item.productNo])
          const scales = product.scales?.filter(scale => scale.status !== 'disable')?.filter(scale => scale.no === item.scaleNo)
          product.memberPrice = -1
          product.isMemberDiscount = false
          if (scales[0]) {
            if (scales[0].saleCnt !== undefined) {
              product.saleCnt = scales[0].saleCnt
              product.saleTotalCnt = scales[0].saleTotalCnt
            }
            if (!scales[0].isOpenPrice) {
              scales[0].actualPrice = item.activityPrice
              scales[0].discountPrice = scales[0].price ? toDecimal(scales[0].price - item.activityPrice) as number : 0
              product.price = scales[0].price ? scales[0].price : product.price
              product.actualPrice = scales[0].actualPrice || 0
              product.offPrice = scales[0].discountPrice || 0
            }
          }
          product.scales = scales
          return product
        })
        .filter(item => !!item.scales?.length)
        .filter(item => item.isNotSingleInCombo && !item.disable && item.saleCnt !== 0)
      const canSwapBuy = !!(viewActivityProducts.length && surplusCnt)
      const activityProductsPsMap = keyBy(activityProducts, item => `${item.productNo}_${item.scaleNo}`)
      const validProductsPsMap = keyBy(validProducts, item => `${item.productNo}_${item.scaleNo}`)
      singleSwapBuyMap[key] = {
        viewActivityProducts,
        canSwapBuy,
        activityProductsPsMap,
        validProductsPsMap,
      } as IDiscountSingleSwapBuyMapItem
    })
    return singleSwapBuyMap
  }

  /** 单品换购换购品pk map */
  get singleSwapBuyValidProductPkMap () {
    return keyBy(flatten(Object.values(this.discountResult.singleItemSwapBuyMap).map(item => item.validProducts)), 'pk')
  }

  /** 满减餐品 */
  get designatedBuyAgainProducts () {
    const { activityProducts = [] } = this.discountResult.designatedBuyAgain || {}
    const activityProductsGroups = groupBy(activityProducts.filter(item => productMobx.noToViewProductMap[item.productNo]), 'productNo')
    const viewProducts: IViewProduct[] = map(activityProductsGroups, (item, key) => {
      const scaleNos = map(item, 'scaleNo')
      const product = cloneDeep(productMobx.noToViewProductMap[key])
      product.scales?.filter(scale => scale.status !== 'disable')?.forEach(scale => {
        scale.disable = !scaleNos.includes(scale.no)
      })
      return product
    }).filter(item => item.isNotSingleInCombo && item.isShowInMenu && !item.disable && item.saleCnt !== 0)
    return viewProducts
  }

  /** 菜单的营销计算 */
  calcMenu () {
    const mpc = restaurantConfig.mpc
    if (mpc && mpc.eatType !== 'mall') {
      const flatProducts: {
        type?: string;
        categoryNo?: string;
        productNo: string;
        scaleNo?: string;
        modifierGroupNo?: string;
        modifierNo?: string;
        price: number;
      }[] = []
      const inputAction = {}
      // 将当前餐品中的餐品根据营销要求的格式输入到营销的计算器中
      productMobx.products.forEach(product => {
        product.scaleGroup.scales.forEach(scale => {
          ((scale.price !== undefined && scale.price >= 0) || !!scale.isOpenPrice) && flatProducts.push({
            type: product.type,
            categoryNo: product.statisticsCategoryNo,
            productNo: product.no,
            scaleNo: scale.no,
            price: scale.price || 0
          })
        })
        if (restaurantConfig.app === 'mobile' || restaurantConfig.app === 'kiosk') {
          product.modifierGroups?.forEach(modifierGroup => {
            modifierGroup.modifiers?.forEach(modifier => {
              modifier.price > 0 && flatProducts.push({
                type: 'modifier',
                categoryNo: product.statisticsCategoryNo,
                productNo: product.no,
                modifierGroupNo: modifierGroup.no,
                modifierNo: modifier.no,
                price: modifier.price || 0
              })
            })
          })
        }
      })
      if (flatProducts.length || restaurantConfig.app === 'mobile' || restaurantConfig.app === 'kiosk') {
        console.log('🍙 营销 菜单 input', cloneDeep(flatProducts))
        mpc.parseInputData('menu_list', flatProducts, inputAction)
      } else {
        console.error('no flat product for mpc')
      }
    } else {
      this.itemDiscountMap = {}
      this.activities = []
    }
  }

  /** 购物车的营销计算 */
  calcCart () {
    const mpc = restaurantConfig.mpc
    if (mpc && mpc.eatType !== 'mall') {
      const cartItemData: any = cartMobx.availableDiscountItems.map((item) => {
        const product: any = {
          isOrderSwapBuy: item.isOrderSwapBuy,
          addTime: (item as any).addTime || null,
          pk: item.pk,
          detailId: item.pk,
          productNo: item.productNo,
          scaleNo: item.scaleNo,
          categoryNo: item.statisticsCategoryNo,
          price: item.productPrice, // .totalPrice
          addPrice: item.unitAddPrice || 0,
          modifierPrice: item.modifierPrice,
          boxPrice: boxFeeMobx.boxFeeType === 'productBoxFee' && item.isTogo ? item.unitBoxPrice : 0,
          cnt: item.cnt,
          type: item.type
        }
        if (item.detailId) {
          product.orderDetailId = item.detailId
          product.orderParentId = (item as IViewOrderDetail).parentId
          product.orderDisocuntList = cloneDeep(filter(orderMobx.order.discountList, (discount) => discount.detailId === item.detailId))
        }
        if (item?.swapBuyProducts?.length) {
          product.swapBuyProducts = item.swapBuyProducts.map(swap => ({
            addTime: (swap as any).addTime || null,
            pk: swap.pk,
            detailId: swap.pk,
            productNo: swap.productNo,
            scaleNo: swap.scaleNo,
            categoryNo: swap.statisticsCategoryNo,
            price: swap.productPrice, // .totalPrice
            addPrice: item.unitAddPrice || 0,
            modifierPrice: swap.modifierPrice,
            boxPrice: boxFeeMobx.boxFeeType === 'productBoxFee' && swap.isTogo ? swap.unitBoxPrice : 0,
            cnt: swap.cnt,
            type: swap.type
          }))
        }
        if (item?.fullItemNFreeProducts?.length) {
          product.fullItemNFreeProducts = item.fullItemNFreeProducts.map(fullNFree => ({
            addTime: (fullNFree as any).addTime || null,
            pk: fullNFree.pk,
            detailId: fullNFree.pk,
            productNo: fullNFree.productNo,
            scaleNo: fullNFree.scaleNo,
            categoryNo: fullNFree.statisticsCategoryNo,
            price: fullNFree.productPrice, // .totalPrice
            addPrice: item.unitAddPrice || 0,
            modifierPrice: fullNFree.modifierPrice,
            boxPrice: boxFeeMobx.boxFeeType === 'productBoxFee' && fullNFree.isTogo ? fullNFree.unitBoxPrice : 0,
            cnt: fullNFree.cnt,
            type: fullNFree.type
          }))
        }
        return product
      })
      // 配送费
      if (cartMobx.cartResult.expressPrice) {
        if (cartMobx.info.expressList?.length) {
          forEach(cartMobx.info.expressList, (item) => {
            cartItemData.push({
              addTime: null,
              pk: item?.pk,
              detailId: item?.pk,
              productNo: 'express',
              scaleNo: 'express',
              categoryNo: 'express',
              price: item.price,
              modifierPrice: 0,
              cnt: 1,
              type: 'express'
            })
          })
        } else {
          cartItemData.push({
            addTime: null,
            pk: cartMobx.info?.express?.pk,
            detailId: cartMobx.info?.express?.pk,
            productNo: 'express',
            scaleNo: 'express',
            categoryNo: 'express',
            price: cartMobx.cartResult.expressPrice,
            modifierPrice: 0,
            cnt: 1,
            type: 'express'
          })
        }
      }
      // 整单打包费增加打包费项
      if (cartMobx.cartResult.boxPrice > 0 && boxFeeMobx.boxFeeType === 'ordersBoxFee') {
        cartItemData.push({
          addTime: null,
          pk: boxFeeMobx.getBoxPk,
          detailId: boxFeeMobx.getBoxPk,
          productNo: 'box',
          scaleNo: 'box',
          categoryNo: 'box',
          price: cartMobx.cartResult.boxPrice,
          addPrice: 0,
          modifierPrice: 0,
          cnt: 1,
          type: 'box'
        })
      }
      // isOrderSwapBuy标记整单换购
      // inputData购物车餐品过滤整单换购餐品
      const inputData = cartItemData.filter((item: any) => !item.isOrderSwapBuy)
      // orderSwapBuyProducts整单换购餐品
      const orderSwapBuyProducts = cartItemData.filter((item: any) => item.isOrderSwapBuy)
      // 订单时间
      const orderAddTime = cartMobx.ordersId ? orderMobx.order.addTime : null
      // 预约时间
      const orderStartTime = cartMobx.checkHasOrderTimeProduct ? cartMobx.info.menuTime || cartMobx.info.asapTime || cartMobx.info.startTime : cartMobx.getFirstStartTimeFromProductRule || undefined
      if (!cartItemData.length) {
        this.clearCartDiscount()
      } else {
        sstime = Date.now()
        const inputAction = {
          ...this.actionPlan,
          addTime: orderAddTime,
          startTime: orderStartTime,
          orderSwapBuyProducts
        }
        console.log('🍙 营销 购物车 input', cloneDeep(inputData), cloneDeep(inputAction))
        const concessionUsage = mpc.parseInputData('order_settlement', inputData, inputAction)
        this.listenCart(null, concessionUsage)
      }
    } else {
      console.error('🍙 营销 购物车 未加载')
      this.clearCartDiscount()
    }
  }

  listenCart (e: any, concessionUsage: any) {
    const mpc = restaurantConfig.mpc
    if (mpc.eatType === 'mall') {
      return console.error('🍙 营销 菜单 output, eatType拦截', mpc.eatType)
    }
    // if (isEqual(cacheCartConcessionUsage, concessionUsage)) {
    //   console.log('🍙 营销 购物车 output prevent by cache')
    //   return
    // }
    // cacheCartConcessionUsage = concessionUsage
    console.log('🍙 营销 购物车 output', cloneDeep(concessionUsage))
    if (sstime > 0) {
      console.log(`🍙 rtt:${Date.now() - sstime}ms`)
      sstime = 0
    }
    // 如果当前餐品为空则不接受计算结果
    if (cartMobx.availableDiscountItems.length) {
      const offArr = concessionUsage.offArr || []
      const integralMoneyIndex = offArr.findIndex((off: any) => off.offType === 'integralMoney')
      let integralMoneyOff
      if (~integralMoneyIndex) {
        integralMoneyOff = offArr.splice(integralMoneyIndex, 1)[0]
      }
      const floorOffIndex = offArr.findIndex((off: any) => off.offType === 'floor')
      let floorOff
      if (~floorOffIndex) {
        floorOff = offArr.splice(floorOffIndex, 1)[0]
      }
      // const promoCodeOffIndex = offArr.findIndex((off: any) => off.offType === 'promoCode')
      // let promoCodeOff
      // if (~promoCodeOffIndex) {
      //   promoCodeOff = offArr.splice(promoCodeOffIndex, 1)[0]
      // }
      // 当前有tagId则统一在offItems处理，没有tagId放到orderPlanOff里 为了打印的时候做区分
      const orderPlanOffIndex = offArr.findIndex((off: any) => off.offType === 'plan')
      let orderPlanOff
      if (~orderPlanOffIndex) {
        orderPlanOff = offArr.splice(orderPlanOffIndex, 1)[0]
      }
      this.discountResult = {
        itemMap: concessionUsage.itemMap || {},
        memberCouponMap: concessionUsage.memberCouponMap || {},
        memberItemCouponMap: concessionUsage.memberItemCouponMap || {},
        offArr,
        usePromoCodeStatus: concessionUsage.usePromoCodeStatus,
        sk: concessionUsage.sk,
        version: concessionUsage.version,
        memberId: concessionUsage.memberId || 0,
        memberCardId: concessionUsage.memberCardId || 0,
        getIntegral: concessionUsage.getIntegral || 0,
        integral: concessionUsage.integral,
        isIntegralMoney: concessionUsage.isIntegralMoney,
        floorOff,
        integralMoneyOff,
        promoCodeActivity: concessionUsage.promoCodeActivity,
        // promoCodeOff,
        orderPlanOff,
        floorType: concessionUsage.floorType,
        floorPayType: concessionUsage.floorPayType,
        singleItemSwapBuyMap: concessionUsage.singleItemSwapBuyMap,
        fullItemNFreeMap: concessionUsage.fullItemNFreeMap,
        noPurchasedCardMap: concessionUsage.noPurchasedCardMap || {},
        designatedBuyAgain: concessionUsage.designatedBuyAgain,
        orderSwapBuy: concessionUsage.orderSwapBuy,
        onlyBalancePayMoreOff: concessionUsage.onlyBalancePayMoreOff,
        onlyBalancePayRechargeMoney: concessionUsage.onlyBalancePayRechargeMoney,
        mockRechargeUseCouponMoreOff: concessionUsage.mockRechargeUseCouponMoreOff,
        mockRechargeCanUseCouponIds: concessionUsage.mockRechargeCanUseCouponIds
      }
      this.checkCoupon()
      // this.checkLogin()
      feeMobx.calcFee()
      // 自动计算满送
      cartMobx.autoFullNFree()
    } else {
      this.discountResult.memberId = concessionUsage.memberId || 0
      this.discountResult.memberCardId = concessionUsage.memberCardId || 0
      this.discountResult.memberCouponMap = concessionUsage.memberCouponMap || {}
      this.discountResult.fullItemNFreeMap = concessionUsage.fullItemNFreeMap || {}
      this.discountResult.noPurchasedCardMap = concessionUsage.noPurchasedCardMap || {}
      this.discountResult.designatedBuyAgain = undefined
    }
    // MPC_MEMBER_CHANGED
    restaurantCenter.emit(RESTAURANT_EVENT.MPC_MEMBER_CHANGED, {
      memberId: this.discountResult.memberId,
      memberCardId: this.discountResult.memberCardId,
    })
  }

  listenMenu (e: any, concessionUsage: any) {
    const mpc = restaurantConfig.mpc
    if (mpc.eatType === 'mall') {
      return console.error('🍙 营销 菜单 output, eatType拦截', mpc.eatType)
    }
    // if (isEqual(cacheMenuConcessionUsage, concessionUsage)) {
    //   console.log('🍙 营销 菜单 output prevent by cache')
    //   return
    // }
    // cacheMenuConcessionUsage = concessionUsage
    console.log('🍙 营销 菜单 output', cloneDeep(concessionUsage))
    const { itemMap, orderPlan, activities } = concessionUsage
    this.itemDiscountMap = itemMap
    this.activities = activities
    // 处理 餐品级自定义优惠
    let itemPlanMap: {
      [productNo: string]: IDiscountPlanConfig;
    } = {}
    forEach(itemMap, (item: any) => {
      if (!itemPlanMap[item.productNo] && item.plan) {
        itemPlanMap[item.productNo] = {
          planId: item.plan.planId,
          tags: item.plan.tags.map((tag: any) => ({
            tagId: tag.planTagId,
            reason: tag.tagName,
            value: tag.discountValue,
            type: tag.discountType,
            isIncludeModifier: tag.isIncludeModifier
          })),
          reasons: item.plan.discountReasons,
          roles: item.plan.roles
        }
      }
    })
    this.itemPlanMap = itemPlanMap
    if (orderPlan) {
      if (orderPlan.discountReasons) {
        this.orderPlan.reasons = orderPlan.discountReasons
      }
      if (orderPlan.tags) {
        this.orderPlan.tags = orderPlan.tags.map((tag: any) => {
          return {
            tagId: tag.planTagId,
            reason: tag.tagName,
            value: tag.discountValue,
            type: tag.discountType
          }
        })
      }
      if (orderPlan.planId) {
        this.orderPlan.planId = orderPlan.planId
      }
      if (orderPlan.roles) {
        this.orderPlan.roles = orderPlan.roles
      }
    } else {
      this.orderPlan = {
        planId: 0,
        reasons: [],
        tags: [],
        roles: []
      }
    }
  }

  /** 清楚购物车计算结果 */
  clearCartDiscount () {
    this.discountResult = getDefaultResult()
    feeMobx.calcFee()
    // MPC_MEMBER_CHANGED
    restaurantCenter.emit(RESTAURANT_EVENT.MPC_MEMBER_CHANGED, {
      memberId: this.discountResult.memberId,
      memberCardId: this.discountResult.memberCardId,
    })
  }

  /** 设置优惠码 */
  addPromoCode (data?: string | null) {
    if (data) {
      if (!this.discountAction.promoCodes.includes(data)) {
        this.discountAction.promoCodes.push(data)
        this.calcCart()
      }
    }
    // Object.assign(this.discountAction, { promoCodes: data ? [data] : [] })
  }

  /** 移除优惠码 */
  removPromoCode (data?: string | null) {
    if (data) {
      const theIndex = this.discountAction.promoCodes.indexOf(data)
      if (~theIndex) {
        this.discountAction.promoCodes.splice(theIndex, 1)
        this.calcCart()
      }
    }
  }

  /** 选择优惠码活动 */
  selectPromoCode (promoCode: string) {
    if (this.discountAction.promoCodes.includes(promoCode)) {
      this.removPromoCode(promoCode)
    } else {
      this.addPromoCode(promoCode)
    }
  }

  /** 设置优惠码数组 */
  setPromoCodes (data?: string[]) {
    Object.assign(this.discountAction, { promoCodes: data || [] })
    this.calcCart()
  }

  clearPromoCode () {
    if (this.discountAction.promoCodes.length) {
      this.discountAction.promoCodes = []
    }
  }

  /** 设置整单手工折扣 */
  setOrderPlan (data?: IDiscountPlan | null) {
    if (!data) {
      if (!this.discountAction.orderPlan) {
        return
      }
    } else {
      if (data.type === this.discountAction.orderPlan?.type && data.value === this.discountAction.orderPlan.value && data.reason === this.discountAction.orderPlan.reason) {
        return
      }
      this.discountAction.isSelectCoupon = true
    }
    this.discountAction = Object.assign(this.discountAction, { orderPlan: data ? { ...data, tagId: data.tagId || null } : (this.discountAction.orderPlan?.isLock) ? this.discountAction.orderPlan : null })
    this.calcCart()
  }

  /** 设置单品手工折扣 */
  setItemPlan (pk: string, data: IDiscountPlan | null, isAutoCalc = false) {
    if (data) {
      if (data.type !== 'changeFee') {
        this.discountAction.itemPlan[pk] = data
        this.discountAction.isSelectCoupon = true
      }
    } else {
      delete this.discountAction.itemPlan[pk]
    }
    if (isAutoCalc) {
      this.calcCart()
    }
  }

  /** 批量设置单品手工折扣 */
  setItemPlans (pkMap: Record<string, number>, data: IDiscountPlan) {
    if (data) {
      for (const pk in pkMap) {
        if (pkMap[pk]) {
          this.discountAction.itemPlan[pk] = data
          this.discountAction.isSelectCoupon = true
        } else {
          delete this.discountAction.itemPlan[pk]
        }
      }
      this.calcCart()
    }
  }

  /** 去除所有优惠动作，注意不触发自动计算 */
  clearDiscountAction () {
    this.discountAction = getDefaultAction()
  }

  /** 从订单还原优惠到优惠动作 */
  restoreDiscountAction (discountList: any[]) {
    // 还原优惠前先清理原先的优惠
    this.clearDiscountAction()
    let orderPlanReason: string = ''
    let orderPlanValue: number | null = null
    let orderPlanType: 'discountRate' | 'discountFee' = 'discountRate'
    let orderPlanIsLock: boolean | undefined
    // let promoCodeValue: string = ''
    let orderPlanTagId
    const promoCodes: string[] = []
    const itemPlanMap: {
      [pk: string]: IDiscountPlan;
    } = {}
    discountList.forEach((discountItem: any) => {
      const isPromoCode = discountItem.discountType.endsWith('PromoCode')
      // const liteDiscountType = isPromoCode ? discountItem.discountType.replace('PromoCode', '') : discountItem.discountType
      if (discountItem.fee > 0) {
        const activityContent = discountItem.activityContent ? JSON.parse(discountItem.activityContent) as {
          tagId?: number;
          discountValue?: number;
          promoCode?: string;
          isIncludeModifier?: boolean;
          isLock?: boolean;
        } : null
        if (discountItem.discountType === 'managerItemDiscount') {
          // ?.discountValue
          if (discountItem.pk && activityContent) {
            itemPlanMap[discountItem.pk] = {
              reason: discountItem.discountName,
              tagId: activityContent?.tagId,
              type: discountItem.activityType, // '"discountRate' 'discountFee', // 减价 | 折扣
              value: activityContent?.discountValue || 0,
              isIncludeModifier: activityContent?.isIncludeModifier || false
            }
          }
        } else if (discountItem.discountType === 'managerDiscount' && activityContent) {
          orderPlanReason = discountItem.discountName
          orderPlanValue = activityContent?.discountValue || 0
          orderPlanType = discountItem.activityType
          orderPlanTagId = activityContent?.tagId
          orderPlanIsLock = activityContent?.isLock
        } else if (isPromoCode && activityContent?.promoCode) {
          if (!promoCodes.includes(activityContent.promoCode)) {
            promoCodes.push(activityContent?.promoCode)
          }
          // promoCodeValue = activityContent?.promoCode
        }
      }
    })
    if (orderPlanValue !== null) {
      this.discountAction.orderPlan = {
        reason: orderPlanReason,
        tagId: orderPlanTagId,
        type: orderPlanType,
        value: orderPlanValue,
        isLock: orderPlanIsLock
      }
    }
    if (promoCodes.length) {
      this.discountAction.promoCodes = [...promoCodes]
    }
    this.discountAction.itemPlan = itemPlanMap
  }

  setDiscountAction (discountAction: IDiscountAction) {
    this.discountAction = discountAction
    this.calcCart()
  }

  /** 切换优惠点餐模式 */
  switchEatType (eatType: TEatType) {
    if (restaurantConfig.mpc && restaurantConfig.mpc.eatType !== eatType) {
      restaurantConfig.mpc.switchEatType(eatType)
    }
    this.switchChannel(cartMobx.channel)
  }

  /** 切换优惠点餐渠道 */
  switchChannel (channel: TChannel) {
    if (restaurantConfig.mpc && restaurantConfig.mpc.channel !== channel) {
      restaurantConfig.mpc.switchChannel(channel)
    }
  }

  /** 验证优惠码 是否可用 */
  async verifyPromoCode (promoCode: string) {
    if (restaurantConfig.mpc) {
      const verifyRes = await restaurantConfig.mpc.checkPromoCode(promoCode)
      if (verifyRes && verifyRes.status === 'enable') {
        return true
      }
    }
    return false
  }

  checkCoupon () {
    const checkedCouponIds: number[] = []
    //   = this.discountAction.selectCouponIds.filter(couponId => {
    //   const couponD = this.discountResult.memberCouponMap[couponId]
    //   return couponD && couponD.status === 'enable'
    // })
    forEach(this.discountResult.memberCouponMap, (coupon, couponId) => {
      if (coupon.isSelect && (coupon.status === 'enable' || coupon.status === 'mutex')) {
        checkedCouponIds.push(parseInt(couponId))
      }
    })
    if (checkedCouponIds.length !== this.discountAction.selectCouponIds.length) {
      this.discountAction.selectCouponIds = checkedCouponIds
    }
    const checkedItemCouponIds: number[] = []
    this.discountAction.selectItemCouponMap = {}
    forEach(this.discountResult.memberItemCouponMap, (coupon, couponId) => {
      if (coupon.canUseProductPk && coupon?.useItem?.pk) {
        this.discountAction.selectItemCouponMap = { ...this.discountAction.selectItemCouponMap, [coupon.memberCouponId]: coupon?.useItem?.pk }
      }
      if (coupon.isSelect && coupon.status === 'enable') {
        checkedItemCouponIds.push(parseInt(couponId))
      }
    })
    if (checkedItemCouponIds.length !== this.discountAction.selectItemCouponIds.length) {
      this.discountAction.selectItemCouponIds = checkedItemCouponIds
    }
    // const unavailableCouponIds: string[] = []
    // forEach(this.discountAction.selectItemCouponMap, (pk, couponId) => {
    //   if (!cartMobx.pkToAvailableDiscountItemMap[pk]) {
    //     unavailableCouponIds.push(couponId)
    //   }
    // })
    // if (unavailableCouponIds.length) {
    //   unavailableCouponIds.forEach(couponId => {
    //     delete this.discountAction.selectItemCouponMap[couponId as any]
    //   })
    // }
  }

  /** 选择优惠券 */
  selectCoupon (coupon: IDiscountCoupon | IDiscountItemCoupon) {
    if (coupon.status === 'disable') {
      return
    }
    const isSingle = !!coupon.products
    if (coupon.isSelect) {
      if (isSingle) {
        if (this.discountAction.selectItemCouponIds.includes(coupon.memberCouponId)) {
          remove(this.discountAction.selectItemCouponIds, (memberCouponId) => memberCouponId === coupon.memberCouponId)
        }
      } else {
        const couponIndex = this.discountAction.selectCouponIds.indexOf(coupon.memberCouponId)
        if (~couponIndex) {
          this.discountAction.selectCouponIds.splice(couponIndex, 1)
        }
      }
    } else {
      if (isSingle) {
        if (!this.discountAction.selectItemCouponIds.includes(coupon.memberCouponId)) {
          this.discountAction.selectItemCouponIds.push(coupon.memberCouponId)
        }
      } else {
        if (!~this.discountAction.selectCouponIds.indexOf(coupon.memberCouponId)) {
          this.discountAction.selectCouponIds.push(coupon.memberCouponId)
        }
      }
    }
    // 介入用户行为不再进行自动优惠
    this.discountAction.isSelectCoupon = true
    this.calcCart()
  }
  /**
   * @param couponMap 单品券string为删除该单品券，对象为增加单品券选择
   * 选择单品优惠券
   * */
  selectSingleProductCoupon (couponMap: string | Record<string, string>, couponType?: boolean) {
    if (typeof couponMap === 'string') {
      this.discountAction.selectItemCouponMap = omit(this.discountAction.selectItemCouponMap, couponMap)
    } else {
      this.discountAction.selectItemCouponMap = couponType ? couponMap : { ...this.discountAction.selectItemCouponMap, ...couponMap }
    }
    // 介入用户行为不再进行自动优惠
    this.discountAction.isSelectCoupon = true
    this.calcCart()
  }

  checkUseCount (pk: string) {
    if (Object.values(this.discountAction.selectItemCouponMap || {}).some(i => i === pk) && !this.discountAction.isSelectCoupon) {
      this.discountAction.isSelectCoupon = true
      this.calcCart()
    }
  }

  /** 设置选中优惠券 */
  setSelectCoupon (selectCouponIds: number[], selectItemCouponIds: number[], promoCodes?: string[]) {
    this.discountAction.selectCouponIds = selectCouponIds
    this.discountAction.selectItemCouponIds = selectItemCouponIds
    if (promoCodes) {
      this.discountAction.promoCodes = promoCodes
    }
    this.calcCart()
  }

  async setIsCashPay (isCashPay = false) {
    if (this.discountResult.floorPayType === 'cash') {
      if (this.discountAction.isCashPay !== isCashPay) {
        this.discountAction.isCashPay = isCashPay
        return this.calcCart()
      }
    }
  }

  /** 使用积分 */
  setIsUseIntegral (isUseIntegral = false) {
    if (this.discountAction.isUseIntegral !== isUseIntegral) {
      this.discountAction.isUseIntegral = isUseIntegral
      return this.calcCart()
    }
  }

  /** 使用余额全额支付才能享受 */
  setOnlyBalancePay (onlyBalancePay = false) {
    if (this.discountAction.onlyBalancePay !== onlyBalancePay) {
      if (onlyBalancePay === false) {
        this.discountAction.onlyBalancePay = onlyBalancePay
        delete this.discountAction.mockCardRechargeId
        delete this.discountAction.mockCardRechargeMoney
        delete this.discountAction.mockCardRechargeUseCoupon
      } else {
        delete this.discountAction.onlyBalancePay
      }
      return this.calcCart()
    }
  }

  /** 删除 onlyBalancePay */
  deleteOnlyBalancePay (cal = false) {
    delete this.discountAction.onlyBalancePay
    delete this.discountAction.mockCardRechargeId
    delete this.discountAction.mockCardRechargeMoney
    delete this.discountAction.mockCardRechargeUseCoupon
    return cal && this.calcCart()
  }

  /** 模拟充值的挡位ID */
  setMockCardRechargeId (rechargeId?: number) {
    if (this.discountAction.mockCardRechargeId !== rechargeId) {
      this.discountAction.isSelectCoupon = false
      if (this.discountAction.onlyBalancePay === undefined && rechargeId !== undefined) {
        this.discountAction.mockCardRechargeId = rechargeId
      } else {
        delete this.discountAction.mockCardRechargeId
      }
      delete this.discountAction.mockCardRechargeMoney
      delete this.discountAction.mockCardRechargeUseCoupon
      return this.calcCart()
    }
  }

  /** 模拟充值的挡位金额 */
  setMockCardRechargeMoney (rechargeMoney?: number) {
    if (this.discountAction.mockCardRechargeMoney !== rechargeMoney) {
      this.discountAction.isSelectCoupon = false
      if (this.discountAction.onlyBalancePay === undefined && rechargeMoney !== undefined) {
        this.discountAction.mockCardRechargeMoney = rechargeMoney
      } else {
        delete this.discountAction.mockCardRechargeMoney
      }
      delete this.discountAction.mockCardRechargeId
      delete this.discountAction.mockCardRechargeUseCoupon
    }
    return this.calcCart()
  }

  /** 模拟充值的券 */
  setMockCardRechargeUseCoupon (useCoupon = false) {
    if (this.discountAction.mockCardRechargeUseCoupon !== useCoupon) {
      if (this.discountAction.onlyBalancePay === undefined && useCoupon !== undefined) {
        this.discountAction.mockCardRechargeUseCoupon = useCoupon
      } else {
        delete this.discountAction.mockCardRechargeUseCoupon
      }
      return this.calcCart()
    }
  }

  /** 重置 */
  reset () {
    this.discountResult = getDefaultResult()
    this.clearDiscountAction()
    this.itemDiscountMap = {}
    this.activities = []
    // cacheCartConcessionUsage = ''
    // MPC_MEMBER_CHANGED
    restaurantCenter.emit(RESTAURANT_EVENT.MPC_MEMBER_CHANGED, {
      memberId: this.discountResult.memberId,
      memberCardId: this.discountResult.memberCardId,
    })
  }

  /** 同步置入虚拟用户的id */
  setVirtualMemberId (memberId: number) {
    this.discountResult.memberId = memberId
  }

  /** 全量刷新营销活动 */
  refresh () {
    const mpc = restaurantConfig.mpc
    if (mpc) {
      mpc.refresh()
    }
  }
}

export default new Discount()
